<script lang="ts">
    import type { TagNodeObject } from '$lib/bbcode/parser/types';
    import * as z from 'zod';
    import { cx } from '$lib/utils/cx';
    import BBCodeTree from '$components/BBCode/BBCodeTree.svelte';

    export let node: TagNodeObject;

    const zAttrs = z.object({
        author: z.string().nullish(),
        class: z.string().nullish(),
    });

    $: attrs = zAttrs.parse(node.attrs);
</script>

<blockquote class={cx('decoda-quote', attrs.class ?? '')}>
    <BBCodeTree nodes={node.content} let:slotName let:slotContent
        ><slot {slotName} {slotContent} /></BBCodeTree
    >
    {#if attrs.author != null && attrs.author !== ''}
        <div class="author text-gray-500">{attrs.author}</div>
    {/if}
</blockquote>
